import flower from "../../../assests/Images/TemplateElement/flower.png";
import JoyLogo from "../../../assests/Images/TemplateElement/JoyPinkLogo.png";
import Squiggle from "../../../assests/Images/TemplateElement/Squiggle.png";
import { DATE } from "../../../shared/constants.js";
import CardTemplate from "./CardTemplate";

export default function TextTemplateBlue({ heading, caption, date, journalId,pageRefresh,ref,menuShow }) {
  return (
    <CardTemplate
      journalId={journalId}
      headingText={heading || ""}
      bodyText={caption || ""}
      date={date || DATE.JOURNAL_FORMAT}
      bgColor="#005cff"
      headingColor="#ff9fcf"
      borderColor="#ff9fcf"
      textColor="#ffffff"
      imageTopLeft={Squiggle}
      imageTopLeftStyle={{
        width: { xs: 40, sm: 60, md: 60 },
        height: { xs: 40, sm: 60, md: 60 },
        top: 10,
        left: 10,
      }}
      imageBottomLeft={flower}
      imageBottomLeftStyle={{
        width: { xs: 30, sm: 50, md: 50 },
        height: { xs: 30, sm: 50, md: 50 },
        bottom: { xs: 16, sm: 30, md: 30 },
        left: { xs: 8, sm: 20, md: 20 },
      }}
      imageBottomRight={JoyLogo}
      imageBottomRightStyle={{
        width: { xs: 16, sm: 24, md: 24 },
        height: { xs: 16, sm: 24, md: 24 },
        bottom: { xs: 5, sm: 5, md: 5 },
        right: { xs: 5, sm: 5, md: 5 },
      }}
      pageRefreshCallback={pageRefresh}
      ref={ref}
      menuShow={menuShow}
    />
  );
}
